module.exports = __webpack_public_path__ + "img/navigation.f37c9851.svg";